import React, { CSSProperties, useState } from "react";
import styled from "styled-components";
import { useEffectNotOnMount } from "../../../../hooks/useEffectNotOnMount";

export const LanguageTabsWrapper = styled.div`
  height: 30px;
  width: 100%;
  display: flex;
  margin-bottom: 15px;
`;

export const LanguageTabWrapper = styled.div`
  display: inline-flex;
  height: 100%;
  width: 40px;
  border-color: rgb(15, 0, 122);
  border-style: solid;
  border-width: 0px 1px 1px 0px;
  align-items: center;
  justify-content: center;
  //background-color: #e4e5f7;
  background-color: white;
  border-radius: 0% 0% 10% 10%;
  &:first-child {
    border-left: 1px solid black;
  }
  &:hover {
    cursor: pointer;
  }
  &.selected {
    //background-color: white;
    background-color: #e4e5f7;
  }
`;

interface ILanguageTabProps {
  text: string;
  onClick: (text: string) => void;
  selected?: boolean;
}

const LanguageTab: React.FC<ILanguageTabProps> = (props) => {
  const { text, selected = false, onClick } = props;

  return (
    <LanguageTabWrapper
      className={selected ? "selected" : ""}
      onClick={() => onClick(text)}
    >
      {text}
    </LanguageTabWrapper>
  );
};

interface ILanguageTabsProps {
  languages: string[];
  setLanguageIndex: (index) => void;
  style?: CSSProperties;
}

const LanguageTabs: React.FC<ILanguageTabsProps> = (props) => {
  const { languages, setLanguageIndex, ...rest } = props;

  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    languages[0]
  );

  useEffectNotOnMount(() => {
    setLanguageIndex(languages.indexOf(selectedLanguage));
  }, [selectedLanguage]);

  return (
    <LanguageTabsWrapper {...rest}>
      {languages.map((language) => (
        <LanguageTab
          text={language}
          key={language + "key"}
          selected={selectedLanguage === language}
          onClick={(lang) => setSelectedLanguage(lang)}
        />
      ))}
    </LanguageTabsWrapper>
  );
};

export default LanguageTabs;
